// extracted by mini-css-extract-plugin
export var colorSquare = "_qu-0";
export var danger = "_qu-5";
export var lightPink = "_qu-8";
export var neutralBlue = "_qu-7";
export var neutralYellow = "_qu-6";
export var normal = "_qu-1";
export var primary = "_qu-2";
export var primaryLight = "_qu-3";
export var solidBlack = "_qu-g";
export var solidGreen = "_qu-b";
export var solidLightBlue = "_qu-d";
export var solidNavy = "_qu-c";
export var solidOrange = "_qu-f";
export var solidPink = "_qu-e";
export var solidRed = "_qu-9";
export var solidYellow = "_qu-a";
export var success = "_qu-4";